import "./Header.css";
const Header = () => {
return (
    <div>
        <h1>POPULAR TOUR PLACES</h1>
    </div>
    )
}

export default Header